import React, { useEffect, useState } from 'react';
import { getBillingUrl, goLogin } from "../../../../common/utils/passUtil";

export default function PassBox(props) {


  const [isAndroid, setIsAndroid] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [priceMap, setPriceMap] = useState([]);

  // console.log(props.lang)

  useEffect(() => {
    if (props.isSbsApp && isAndroid && typeof window !== 'undefined' && window.inapp) {
      // if (props.isSbsApp && isAndroid) { // 테스트용
      const list = props.data.map(item => {
        const prefix = item.module_type === '1' ? 'sub_' : 'term_';
        return {
          productId: prefix + item.inapp_product_id.toLowerCase(),
          productType: item.module_type === '1' ? props.group : 'inapp',
        };
      });

      const products = JSON.stringify(list);

      try {

        const raw = window.inapp.getPriceList(products);
        // const raw = '[{"productId":"sub_cb00g000211","productType":"subs","price":"₩3,300","currencyCode":"KRW"},{"productId":"sub_cb00g000212","productType":"subs","price":"₩6,600","currencyCode":"KRW"},{"productId":"sub_cb00g000213","productType":"subs","price":"₩11,000","currencyCode":"KRW"},{"productId":"term_cb00g000201","productType":"inapp","price":"₩66,000","currencyCode":"KRW"}]';
        const pricesArray = JSON.parse(raw);

        setPriceMap(pricesArray);

      } catch (err) {
        console.error('getPriceList 실행 중 오류:', err);
      }

    }
  }, [props.isSbsApp, isAndroid]);

  useEffect(() => {
    setIsAndroid(props.isAndroid);
    setIsIOS(props.isIOS);
  }, [props.isAndroid, props.isIOS]);

  const checkJoinPlatform = (item, billingUrl) => {

    // 트위터 / 페이스북 유료결제 제한
    const targetDate = new Date('2024-08-27T14:00:00+09:00');
    const currentDate = new Date();

    if (currentDate >= targetDate) {
      if (props.platform === 'T' || props.platform === 'F') {
        const message = props.displayLang == 'ko'
          ? '페이스북 및 트위터를 통한 결제는 불가능합니다.\n다른 로그인 방법을 사용해 결제해 주세요.'
          : 'Payment through Facebook and Twitter is not possible.\nPlease use a different login method to pay.';
        alert(message);
        return false;
      }
    }

    const productName = `${props.groupTitle} ${item.product_name}`;

    props.inappbillingHandler(
      item.module_type == '1' ? props.group : 'inapp',
      props.isAndroid ? item.inapp_product_id : item.ios_inapp_product_id,
      props.isAndroid ? item.inapp_event_product_id : item.ios_inapp_event_product_id,
      productName,
      props.isAndroid ? item.price_app : item.price_ios_app,
      billingUrl
    );
  };

  const renderTextWithLineBreaks = (text) => {
    return text.split('<br>').map((line, index, array) => (
      <span key={index}>
        {line}
        {index < array.length - 1 && <br />}
      </span>
    ));
  };

  return (
    <>
      {
        props.data.map((item, index) => {

          // 안드로이드 제3결제 or 모바일웹 용 billingUrl 
          const billingUrl = getBillingUrl(
            props.loginJwt,
            props.isSbsApp ? 'app' : 'mobile',
            item.module_type === '1' ? props.group : 'inapp',
            props.isSbsApp ? item.app_product_id : item.product_id
          );

          let priceContent = '';
          if (props.isSbsApp) {
            if (isAndroid) {
              console.log(priceMap);

              const productIdPart = item.inapp_product_id.toLowerCase();
              const priceItem = priceMap.find(p => p.productId.toLowerCase().includes(productIdPart));
              const displayPrice = priceItem ? priceItem.price : item.price_app;

              let monthlyPriceText = '';
              if (priceItem && item.price_sub_app && item.module_type === '2') {
                const numericPrice = parseInt(priceItem.price.replace(/[^\d]/g, ''), 10);
                const monthlyPrice = Math.round(numericPrice / 12);
                const currencySymbol = priceItem.price.replace(/[\d,]/g, '').trim();
                monthlyPriceText = `${currencySymbol}${monthlyPrice.toLocaleString()}`;
              }

              const periodUnit =
                props.lang === 'ko'
                  ? item.module_type === '1'
                    ? '/월'
                    : item.module_type === '2'
                      ? '/연'
                      : ''
                  : item.module_type === '1'
                    ? '/month'
                    : item.module_type === '2'
                      ? '/year'
                      : '';

              priceContent = (
                <>
                  {displayPrice}<span className="sText">{item.price_sub_app}</span>

                </>
              );

            } else if (isIOS) {
              priceContent = (
                <>
                  {item.price_ios_app}
                  {item.price_sub_ios_app && (
                    <span className="sText">{item.price_sub_ios_app}</span>
                  )}
                </>
              );
            }
          } else {
            priceContent = (
              <>
                {item.price_m}
                {item.price_sub ? (
                  <span className="sText">{item.price_sub}</span>
                ) : ''}
              </>
            );
          }

          return (
            <div key={`pass-box-${props.platform}-${index}`} className={`passModule_type${item.module_type}`}>
              {item.label && (
                <span className={`moduleLabel-${item.label.type}`}>
                  {item.label.text}
                </span>
              )}
              {item.module_type === '2' && (
                <span className="moduleLabel-sale">16% 할인</span>
              )}
              <a href="#" className="passModuleLink" onClick={(event) => {
                event.preventDefault();
                checkJoinPlatform(item, billingUrl);
              }}>
                <div className="passModuleCont">
                  <strong className="passModuleTitle">{item.product_name}</strong>
                  <div class="passModuleSText">{renderTextWithLineBreaks(item.sub_description)}</div>
                  <div className="passModuleNumber">{priceContent}</div>
                </div>
                {/* <div className="passModuleInfo_w">
                  {item.support.map((support, index) => (
                    <div key={`pass-box-support-${index}`} className="passModuleInfo_text">
                      {support.info && (
                        <>
                          <span dangerouslySetInnerHTML={{ __html: support.info }} />
                          <span dangerouslySetInnerHTML={{ __html: support.label }} />
                        </>
                      )}
                    </div>
                  ))}
                </div> */}
              </a>
            </div>
          );
        })
      }
    </>
  );
}
